module.exports = __webpack_public_path__ + "static/steps-performed-by-hacker-3fc07879a267cfd22e03287f84c4d4f9.png";